(function(){
 'use strict';
 function start(root){
  if(root.dataset.cmReady)return;
  root.dataset.cmReady='1';
  var buttons=root.querySelectorAll('[data-cm-select-look]');
  var looks=root.querySelectorAll('[data-cm-look]');
  buttons.forEach(function(button){
   button.addEventListener('click',function(){
    var choice=button.getAttribute('data-cm-select-look');
    looks.forEach(function(look){look.hidden=look.getAttribute('data-cm-look')!==choice;});
    buttons.forEach(function(btn){btn.setAttribute('aria-pressed',String(btn===button));});
   });
  });
  root.addEventListener('click',function(event){
   var a=event.target && event.target.closest && event.target.closest('a[data-cm-product-id]');
   if(!a||!root.contains(a))return;
   var id=a.getAttribute('data-cm-product-id')||'';
   if(!/^\d{10,20}$/.test(id))return;
   try{
    var analytics=window.Shopify&&window.Shopify.analytics;
    if(!analytics||typeof analytics.publish!=='function')return;
    var look=a.closest('[data-cm-look]');
    var list=look?look.querySelectorAll('a[data-cm-product-id]'):[];
    var pos=Array.prototype.indexOf.call(list,a);
    var promise=analytics.publish('camode:select_item',{item_id:'shopify_ZZ_'+id,product_id:id,item_name:a.getAttribute('data-cm-product-name')||'',item_list_id:'camode_look_studio',item_list_name:'CAMODE Look Studio',index:pos<0?0:pos});
    if(promise&&typeof promise.catch==='function')promise.catch(function(){});
   }catch(e){}
  });
 }
 function run(){document.querySelectorAll('[data-cm-studio]').forEach(start);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
 document.addEventListener('shopify:section:load',run);
})();